<template>
    <span data-component="BookingGroupNameBadge"
          class="label label-neutral booking-group-name">
        {{ name }}
    </span>
</template>

<script>
// This uses the styles of the badge used on the cart and the Today screen but that element also includes an edit icon.
// and is clickable.
// TODO: we should be able to refactor this component to cover both use cases.
export default {
    name: 'BookingGroupNameBadge',

    props: {
        name: {
            type: String,
            required: true,
        },
    },
};
</script>

<style>
.booking-group-name {
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
